module.exports = __webpack_public_path__ + "media/images/payment-providers/paysafecard-card-6b7b88c82b453ea40812bbdac64d1c9f.svg";